export const taskStatusData = [
    { value: 'Completed', label: 'Completed' },
    { value: 'Work In Process', label: 'Work In Process' },
]